module.exports = __webpack_public_path__ + "static/media/impresion.e02b4133.png";